
import SAFTPage from './saftpage'

export default SAFTPage;